module.exports = {
      id: "comm-cinema-usage",
      viewBox: "0 0 415.94 49.818",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-cinema",
      toString: function () {
        return this.url;
      }
    }